import { Avatar, SxProps, Theme } from '@mui/material';
import * as React from 'react';
import { colors } from '../../theme';

interface Props {
  firstName?: string;
  lastName?: string;
  mail?: string;
  size?: number;
  sx?: SxProps<Theme>;
}

export const LetterAvatar: React.FC<Props> = ({ firstName, lastName, mail, size = 50, sx }) => {
  const initials = (firstName && lastName ? `${firstName?.[0]}${lastName?.[0]}` : mail?.[0])?.toUpperCase();
  const bgColorHex = colors.secondary;
  const fontColor = colors.text.primary;
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize: size / 2,
        color: fontColor,
        backgroundColor: bgColorHex,
        ...sx,
      }}
    >
      {initials}
    </Avatar>
  );
};
